import { Text } from "components/commons";
import { formatAmount } from "utils";
import styles from "../dry-stock.module.scss";

export const lubricantSalesMapper = ({ val, isLubricant }) => {
  const {
    sku,
    name,
    variant,
    originalPricePerItem,
    totalDiscount,
    quantity,
    originalTotalAmount,
    category,
  } = val;

  // const finalDiscount = totalDiscount <= 0 ? premiumDiscount?.discountPremium || 0 : -totalDiscount;
  const finalAmount = originalTotalAmount - Math.abs(totalDiscount ?? 0);

  const fields = {
    itemCode: (
      <>
        <Text className={styles.content}>{sku ?? "-"}</Text>
      </>
    ),
    product: (
      <>
        <Text className={styles.content}>{name ?? ""}</Text>
      </>
    ),
    variant: (
      <>
        <Text className={styles.content}>{variant ?? ""}</Text>
      </>
    ),
    unitPrice: (
      <>
        <Text className={styles.content}>{formatAmount(originalPricePerItem ?? 0)}</Text>
      </>
    ),
    quantitySold: (
      <>
        <Text className={styles.content}>{quantity ?? 0}</Text>
      </>
    ),
    amount: (
      <>
        <Text className={styles.content}>{formatAmount(originalTotalAmount ?? 0)}</Text>
      </>
    ),
    discounts: (
      <>
        <Text className={totalDiscount < 0 ? styles.negative : styles.content}>
          {totalDiscount < 0 ? "-" : ""}
          {formatAmount(Math.abs(totalDiscount ?? 0))}
        </Text>
      </>
    ),
    finalAmount: (
      <>
        <Text className={styles.content}>{formatAmount(finalAmount ?? 0)}</Text>
      </>
    ),
  };

  return isLubricant
    ? {
        productCategory: (
          <>
            <Text className={styles.content}>{category ?? ""}</Text>
          </>
        ),
        ...fields,
      }
    : fields;
};
